// src/utils/apiErrorHandler.js
// ✅ Classe errore con messaggi puliti e codici strutturati

export class ApiError extends Error {
    constructor(error, context = '') {
        super();
        this.name = 'ApiError';
        this.context = context;
        this.originalError = error;
        this.status = error?.response?.status;
        this.code = error?.response?.data?.code;
        this.message =
            error?.response?.data?.message ||
            error?.message ||
            `Errore: ${context}`;
    }

    isUnauthorized() { return this.status === 401; }
    isForbidden() { return this.status === 403; }
    isNotFound() { return this.status === 404; }
    isRateLimit() { return this.status === 429; }
    isServerError() { return this.status >= 500; }
    isAiUpgrade() { return this.code === 'AI_PLAN_UPGRADE_REQUIRED'; }
    isAiQuota() { return this.code === 'AI_QUOTA_EXCEEDED'; }
    isLimitReached() { return this.code === 'LIMIT_REACHED'; }
}

// Helper per usarlo negli hook senza try/catch ripetuto
export const handleApiError = (error, context = '') => {
    if (error instanceof ApiError) return error;
    return new ApiError(error, context);
};